import * as React from 'react';
import { useContext, useState} from 'react';
import { IChangeEventHandler } from '../../_types/nav';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Grid, Button } from '@material-ui/core';
import { IObjectPolicy, IObjectPolicyTerm, IPolicyDefinition, IPolicyObject, PolicyObjectCN, PolicyObjectTypeOptions } from '../../_types/ewpolicy';
import Chip from '@material-ui/core/Chip';
import QueryFieldSelector from '../Search/FieldSelector';
import { search_param } from '../../_types/search';
import { AuthContext } from '../../_auth/AuthContext';
import { ClonePolicy, CreatePolicy, ExpirePolicy } from '../../_service/ewpolicy';


interface Props {
    onChange: IChangeEventHandler<IObjectPolicy>;
    policy: IObjectPolicy;
    definition: IPolicyDefinition;
    allowEdit: boolean;
    policyObject: IPolicyObject
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    param: {
      marginLeft: theme.spacing(2),
      marginTop: theme.spacing(1)
    }
  }),
);

const Policy: React.FC<Props> = (prop: Props) => {

    const classes = useStyles();
    const { user } = useContext(AuthContext);
    const [editPolicy, setEditPolicy] = useState<IObjectPolicy | null>(null);
    //const userState: IUserState = useContext(AuthContext); 



const isChanged = () => {

    let toReturn: boolean = false;

    if (editPolicy) {
        editPolicy.terms.forEach((p) => {
            let orig: IObjectPolicyTerm | undefined = prop.policy.terms.find(c => c.param_cn == p.param_cn);
            if (orig !== undefined) {
                toReturn = toReturn || p.param_value !== orig.param_value;
            }
        });
    }

    return toReturn;
}

const paramChange = (param: search_param) => {
    
   
    

    let policy: IObjectPolicy = { ...prop.policy };
    let p: IObjectPolicyTerm | undefined = policy.terms.find(g => g.param_cn == param.column_cn);
    if (p !== undefined) {
       p.param_value = param.values[0];
       prop.onChange(policy);
    }

}



const enterEditMode = () => {
    let editPolicy: IObjectPolicy = ClonePolicy(prop.policy);

    editPolicy.editing = true;
    prop.policy.editing = true;
    
    setEditPolicy(editPolicy);
    prop.onChange(ClonePolicy(editPolicy));

}
const exitEditMode = () => {
    let inEdit: IObjectPolicy = ClonePolicy(editPolicy!);
    
    inEdit.editing = false;
    setEditPolicy(null);
    prop.onChange(inEdit);
 
   
}

const createPolicy = () => {


    CreatePolicy(prop.policyObject, prop.policy).then(r => {
        prop.onChange(r);
    })
    setEditPolicy(null);

};

const expirePolicy = () => {


    ExpirePolicy(prop.policy.id!).then((r) => {
        if (r !== null) {

            prop.onChange(r);
        }
    });
    setEditPolicy(null);

};

const isMe = () => {
    let cn: string = PolicyObjectCN(prop.policyObject.objectType);
    let toReturn: boolean =  (prop.policyObject.id === prop.policy.object_id && cn === prop.policy.object_type_cn);

    if (prop.policyObject.objectType === PolicyObjectTypeOptions.root) {
        toReturn = false;
    }
    return toReturn;
}

const getLabel = () => {



    let cn = PolicyObjectCN(prop.policyObject.objectType);

    let toReturn: string = "meh";

    if ((prop.policyObject.id === prop.policy.object_id) && (cn === prop.policy.object_type_cn)) {
        toReturn = prop.policyObject.displayName ? prop.policyObject.displayName : "Explicit";
    } else {
        toReturn = prop.policy.object_type_cn.replace("objecttype.", "");
    }

    if (toReturn === "root") { toReturn = "Default"; }
    return toReturn;
}

return (

    <Grid container direction="column" justify="flex-start" alignItems="stretch">
        <Grid item>
            <Grid container direction="row" justify="flex-start" alignItems="stretch" spacing={1}>
                <Grid item><Button disabled={!prop.allowEdit || editPolicy!==null || prop.policy.disabled} onClick={(e) => {enterEditMode()}}>{prop.definition.name}</Button></Grid>
                <Grid item><Chip size="small" variant="outlined" color="primary" label={getLabel()}></Chip></Grid>
                <Grid item><i>{prop.definition.description}</i></Grid>
            </Grid>
        </Grid>
        <Grid item>
            { prop.policy.terms.map((t,i) => {
                let policy_cn = prop.definition.policy_cn;
                let termDef = prop.definition.terms.find(g => g.param_cn === t.param_cn.replace(policy_cn,"").replace(".",""));
                let sp: search_param = { column_cn: t.param_cn, comparison: "equals", values: [t.param_value]};

                if (termDef) { 
                    return (
                        <Grid key={i} container direction="row" justify="flex-start" alignItems="stretch" spacing={1}>
                            <Grid item className={classes.param}><b>{termDef.name}:</b></Grid>
                            <Grid item><QueryFieldSelector onChange={paramChange} disabled={!prop.allowEdit || editPolicy===null} selector_cn={termDef.selector_cn} searchParam={sp}/> </Grid>
                        </Grid>
                    )
                } else {
                    return (<span></span>)
                }
            })}
        </Grid>
        <Grid item>
            <Grid container direction="row" justify="flex-start" alignItems="stretch" spacing={1}>
                { isMe() && editPolicy && !isChanged() && (
                    <Grid item><Button variant="outlined" color="primary" onClick={(e) => { expirePolicy() }}>Expire</Button></Grid>
                )}
                { editPolicy && isChanged() && (
                    <Grid item><Button variant="outlined" color="primary" onClick={(e) => { createPolicy() }}>Update</Button></Grid>
                )}
                { editPolicy && (
                    <Grid item><Button variant="outlined" color="primary" onClick={(e) => { exitEditMode() }}>Cancel</Button></Grid>
                )}
            </Grid>
        </Grid>
            
    
    </Grid>

    )
}

export default Policy;